export default __webpack_public_path__ + "static/media/samples.742eae2d.png";